var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "large-deposit-container" },
    [
      _vm.bannerImage
        ? _c("div", { staticClass: "deposit-header" }, [
            _c("img", {
              staticStyle: { width: "100%" },
              attrs: { src: _vm.bannerImage, alt: "" },
            }),
          ])
        : _vm._e(),
      _c("div", { staticClass: "bank-info-section" }, [
        _c("div", { staticClass: "bank-account hk-account" }, [
          _vm._m(0),
          _vm.gameCode == "cztxtw"
            ? _c("div", { staticClass: "account-details" }, [
                _vm._m(1),
                _vm._m(2),
                _vm._m(3),
                _vm._m(4),
                _vm._m(5),
              ])
            : _vm._e(),
          _vm.gameCode == "sgyjltw"
            ? _c("div", { staticClass: "account-details" }, [
                _vm._m(6),
                _vm._m(7),
                _vm._m(8),
                _vm._m(9),
                _vm._m(10),
                _vm._m(11),
                _vm._m(12),
              ])
            : _vm._e(),
        ]),
        _vm._m(13),
      ]),
      _c("div", { staticClass: "form-toggle" }, [
        _c(
          "button",
          {
            staticClass: "toggle-btn",
            on: {
              click: function ($event) {
                _vm.showForm = !_vm.showForm
              },
            },
          },
          [
            _c("i", { staticClass: "icon-form" }),
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.showForm ? "隱藏匯款表單" : "顯示匯款表單") +
                "\n\t\t"
            ),
          ]
        ),
      ]),
      _vm.showForm
        ? _c("BankRemitForm", {
            ref: "bankRemitForm",
            on: { success: _vm.handleSuccess },
          })
        : _vm._e(),
      _c("BankRemitData", { ref: "bankRemitData" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "account-header" }, [
      _c("h3", [
        _c("i", { staticClass: "icon-tw" }),
        _vm._v("\n\t\t\t\t\t台幣儲值帳號\n\t\t\t\t"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行：")]),
      _c("span", { staticClass: "value" }, [_vm._v("國泰世華銀行(世貿分行)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("戶名(代理金流商)：")]),
      _c("span", { staticClass: "value" }, [_vm._v("贊佳數位行销有限公司")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行代碼：")]),
      _c("span", { staticClass: "value" }, [_vm._v("013")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行帳戶：")]),
      _c("span", { staticClass: "value" }, [_vm._v("065-03-5014947")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "warning-text" }, [
      _c("strong", [_vm._v("*注意：")]),
      _vm._v(
        "該帳號只支持台湾帳戶玩家使用,只支持「台幣」轉帳，詳情請詢問客服\n\t\t\t\t"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行：")]),
      _c("span", { staticClass: "value" }, [_vm._v("國泰世華銀行(南門分行)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("戶名(代理金流商)：")]),
      _c("span", { staticClass: "value" }, [_vm._v("荷馬娛樂股份有限公司")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行代碼：")]),
      _c("span", { staticClass: "value" }, [_vm._v("013")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行帳戶：")]),
      _c("span", { staticClass: "value" }, [_vm._v("076-03-501098-6")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行地址：")]),
      _c("span", { staticClass: "value" }, [_vm._v("台北市羅斯福路二段5號")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "detail-row" }, [
      _c("span", { staticClass: "label" }, [_vm._v("銀行電話：")]),
      _c("span", { staticClass: "value" }, [_vm._v("(02)2322 2777")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "warning-text" }, [
      _c("strong", [_vm._v("*注意：")]),
      _vm._v(
        "該帳號只支持台湾帳戶玩家使用,只支持「台幣」轉帳，詳情請詢問客服\n\t\t\t\t"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bank-account tw-account" }, [
      _c("div", { staticClass: "account-header" }, [
        _c("h3", [
          _c("i", { staticClass: "icon-hk" }),
          _vm._v("\n\t\t\t\t\t港幣儲值帳號\n\t\t\t\t"),
        ]),
      ]),
      _c("div", { staticClass: "account-details" }, [
        _c("div", { staticClass: "detail-row" }, [
          _c("span", { staticClass: "label" }, [_vm._v("銀行：")]),
          _c("span", { staticClass: "value" }, [
            _vm._v("Bank of China (Hong Kong) Limited, HongKong"),
          ]),
        ]),
        _c("div", { staticClass: "detail-row" }, [
          _c("span", { staticClass: "label" }, [_vm._v("戶名(代理金流商)：")]),
          _c("span", { staticClass: "value" }, [
            _vm._v("MIAOPLAY ENTERTAINMENT NETWORK LIMITED"),
          ]),
        ]),
        _c("div", { staticClass: "detail-row" }, [
          _c("span", { staticClass: "label" }, [_vm._v("銀行帳號：")]),
          _c("span", { staticClass: "value" }, [_vm._v("012")]),
        ]),
        _c("div", { staticClass: "detail-row" }, [
          _c("span", { staticClass: "label" }, [_vm._v("SWIFT CODE：")]),
          _c("span", { staticClass: "value" }, [_vm._v("BKCHKHKHHXXX")]),
        ]),
        _c("div", { staticClass: "detail-row" }, [
          _c("span", { staticClass: "label" }, [_vm._v("匯款(轉帳)帳號：")]),
          _c("span", { staticClass: "value" }, [_vm._v("012-687-2-033788-7")]),
        ]),
        _c("div", { staticClass: "detail-row" }, [
          _c("span", { staticClass: "label" }, [_vm._v("收款銀行地址：")]),
          _c("span", { staticClass: "value" }, [
            _vm._v("BANK OF CHINA TOWER 1GARDEN ROAD,CENTRAL,HONGKONG"),
          ]),
        ]),
        _c("div", { staticClass: "warning-text" }, [
          _c("strong", [_vm._v("*注意：")]),
          _vm._v(
            "該帳號只支持香港帳戶玩家使用·只支持「港幣」轉帳·詳情請詢問客服\n\t\t\t\t"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }